import { Box, Tabs, Tab, Button, Stack } from "@mui/material"
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useMainStore } from "./store";

const CodeView = observer(() => {

  const [value, setValue] = useState("console");
  const store = useMainStore()

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const copy = () => {
    navigator.clipboard.writeText(value === "console"? store.consoleCode: store.imacrosCode)
  }

  return (
    <Box sx={{ width: "40vw", display: "flex", flexDirection: "column" }}>
      <Stack direction="row" sx={{ alignItems: "center", pr: 2 }}>
        <Tabs value={value} onChange={handleChange} sx={{ mt: 1, mx: 2  }}>
          <Tab label="Console code" value="console" />
          <Tab label="Key -> value" value="raw" />
          {/* <Tab label="Imacros" value="imacros"/> */}
        </Tabs>
        <Button variant="contained" sx={{ ml: "auto" }} disabled={!store.values.slug} onClick={copy}>
          Скопировать код
        </Button>
      </Stack>
      <Box sx={{ bgcolor: "grey.100", flex: 1, whiteSpace: "pre", overflow: "auto", px: 2, pt: 1, fontSize: 14 }}>
        { value === "console" && store.consoleCode}
        { value === "imacros" && store.imacrosCode}
        { value === "raw" && store.rawCode}
      </Box>
    </Box>
  )
})

export default CodeView